module.exports = __webpack_public_path__ + "media/images/real-last-4-a6a01dde5fe127b93bf91f36c3aef77e.png";